/* PilotstoriesArt product form: Edition / Finish / Size pickers, price, wall preview, sticky add-to-cart bar.
   Mirrors design-reference/Product.dc.html (state: view, edition, finish, size) and the quick view in Collection.dc.html.
   Reads <script type="application/json" data-psa-product-json> inside each [data-psa-product] root. */
(function () {
  'use strict';

  function fmt(cents, format) {
    var n = (cents / 100).toFixed(2);
    var whole = n.slice(-3) === '.00';
    var parts = n.split('.');
    var intComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var intDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return String(format || '€{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return intComma;
        case 'amount_with_comma_separator': return whole ? intDot : intDot + ',' + parts[1];
        case 'amount_no_decimals_with_comma_separator': return intDot;
        case 'amount_with_space_separator': return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + (whole ? '' : ',' + parts[1]);
        case 'amount_with_apostrophe_separator': return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'") + (whole ? '' : '.' + parts[1]);
        default: return whole ? intComma : intComma + '.' + parts[1];
      }
    }).replace(/<[^>]*>/g, '');
  }

  function Product(root) {
    this.root = root;
    this.data = JSON.parse(root.querySelector('[data-psa-product-json]').textContent);
    var d = this.data;
    this.state = { edition: d.initial.edition, finish: d.initial.finish, size: d.initial.size, view: 'photo' };
    this.bind();
    this.observeAtc();
    this.render(false);
  }

  Product.prototype.size = function () {
    var s = this.state, d = this.data;
    return s.edition === 'signed' && d.signed ? d.signed.size : s.size;
  };

  Product.prototype.variant = function () {
    var s = this.state, d = this.data;
    if (s.edition === 'signed' && d.signed) {
      return d.signed.variants.filter(function (v) { return v.finish === s.finish; })[0] || d.signed.variants[0];
    }
    var size = this.size();
    return d.variants.filter(function (v) { return (!d.hasFinish || v.finish === s.finish) && v.size === size; })[0] || null;
  };

  Product.prototype.setPicker = function (name, value) {
    var group = this.root.querySelector('[data-psa-picker="' + name + '"]');
    if (!group) return;
    var cur = null;
    group.querySelectorAll('.psa-vp__opt').forEach(function (b) {
      var on = b.getAttribute('data-value') === value;
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.setAttribute('tabindex', on ? '0' : '-1');
      if (on) cur = b.querySelector('.psa-vp__row').textContent;
    });
    var c = group.querySelector('.psa-vp__current');
    if (c && cur != null) c.textContent = cur;
  };

  Product.prototype.render = function (fromUser) {
    var s = this.state, d = this.data, self = this;
    var signed = s.edition === 'signed' && d.signed;
    var size = this.size();
    this.setPicker('edition', s.edition);
    this.setPicker('finish', s.finish);
    // Size options: prices for the current finish; when signed, only the signed size
    this.root.querySelectorAll('[data-psa-picker="size"] .psa-vp__opt').forEach(function (b) {
      var val = b.getAttribute('data-value'), meta = b.querySelector('.psa-vp__meta');
      if (signed) {
        var sv = self.variant();
        b.disabled = val !== d.signed.size;
        if (meta) meta.textContent = val === d.signed.size ? (d.quick ? d.labels.signed : fmt(sv.price, d.moneyFormat)) : '—';
      } else {
        var v = d.variants.filter(function (x) { return (!d.hasFinish || x.finish === s.finish) && x.size === val; })[0];
        b.disabled = !v || !v.available;
        if (meta) meta.textContent = v ? fmt(v.price, d.moneyFormat) : '—';
      }
    });
    this.setPicker('size', size);
    var v = this.variant();
    var idInput = this.root.querySelector('[data-psa-variant-id]');
    if (idInput && v) idInput.value = v.id;
    var avail = !!(v && v.available);
    this.root.querySelectorAll('[data-psa-atc-button]').forEach(function (b) {
      b.disabled = !avail;
      var lab = b.querySelector('span:not(.psa-btn__icon)');
      if (lab) lab.textContent = avail ? d.labels.add : d.labels.soldOut;
    });
    this.root.querySelectorAll('[data-psa-price]').forEach(function (p) { if (v) p.textContent = fmt(v.price, d.moneyFormat); });
    // Shipping cost under the price (6 October 2026): the rate for this finish and size; the plain note when there is none
    var noteCost = this.root.querySelector('[data-psa-note-cost]');
    if (noteCost) {
      var hasShip = !!(v && v.ship && !signed);
      noteCost.hidden = !hasShip;
      var notePlain = this.root.querySelector('[data-psa-note-plain]');
      if (notePlain) notePlain.hidden = hasShip;
      var shipEl = noteCost.querySelector('[data-psa-ship]');
      if (hasShip && shipEl) shipEl.textContent = v.ship;
    }
    var panel = this.root.querySelector('[data-psa-signed-panel]');
    if (panel) panel.hidden = !signed;
    var dims = signed ? d.signed.dims : (d.sizes[size] || null);
    var sizeLabel = dims ? dims.label : '';
    var finishLabel = d.finishes[s.finish] ? d.finishes[s.finish].label : '';
    // Info rows. The fine-art print in the large size has its own delivery time and Christmas date (WhiteWall, 23 October 2026)
    var dk = s.finish === 'fine' && d.notes.largeSize && size === d.notes.largeSize ? 'large' : s.finish;
    var dn = this.root.querySelector('[data-psa-delivery-note]');
    if (dn && d.notes.delivery[dk]) dn.textContent = d.notes.delivery[dk];
    var gn = this.root.querySelector('[data-psa-gift-note]');
    // The signed edition has its own, longer delivery: no open-print date while it is chosen (interface review, 23 October 2026)
    if (gn && d.notes.gift) { gn.textContent = signed ? '' : d.notes.gift[dk] || ''; gn.closest('[data-psa-gift-row]').hidden = !gn.textContent; }
    // The link to the Christmas dates only next to a sentence that has a date (QA, 27 October 2026)
    var gl = this.root.querySelector('[data-psa-gift-link]');
    if (gl && d.notes.giftDate) gl.hidden = signed || !d.notes.giftDate[dk];
    var fnote = this.root.querySelector('[data-psa-finish-note]');
    if (fnote && d.notes.finish[s.finish]) fnote.textContent = d.notes.finish[s.finish];
    // Accordion text for the selected finish ("Gallery-grade wall art": acrylic text or fine-art text)
    this.root.querySelectorAll('[data-psa-finish-only]').forEach(function (el) { el.hidden = el.getAttribute('data-psa-finish-only') !== s.finish; });
    // Wall preview: the drawing's 300 × 375 cm wall, or a room photo's wall (data-wall-w cm wide, 4:5); the print grows up from its bottom edge
    var print = this.root.querySelector('[data-psa-wall-print]');
    if (print && dims && dims.w) {
      var ww = +print.getAttribute('data-wall-w') || 300, wh = ww * 1.25, bAttr = print.getAttribute('data-border');
      var acrylic = s.finish === 'acrylic', wall = d.wall || (bAttr !== null ? { border: +bAttr } : null);
      // Signed-edition page (design-reference/Product Signed.dc.html) and room photo: the fine-art print's white border is drawn to scale as padding
      var b = wall && wall.border && !acrylic ? wall.border : 0;
      var pw = (dims.w + 2 * b) / ww * 100, ph = (dims.h + 2 * b) / wh * 100;
      print.style.width = pw.toFixed(2) + '%';
      print.style.height = ph.toFixed(2) + '%';
      // Room photo: the wall's light map, clipped to the print (same timing as the print's size change)
      var light = this.root.querySelector('[data-psa-wall-light]');
      if (light) {
        var cx = +print.getAttribute('data-cx'), by = +print.getAttribute('data-bottom');
        light.style.clipPath = 'inset(' + (100 - by - ph).toFixed(2) + '% ' + (100 - cx - pw / 2).toFixed(2) + '% ' + by + '% ' + (cx - pw / 2).toFixed(2) + '%)';
      }
      var img = print.querySelector('img');
      if (wall) {
        print.style.padding = b ? (b / ww * 100).toFixed(4) + '%' : '0';
        print.style.background = b ? '#FFFFFF' : 'transparent';
        if (img) img.style.boxShadow = acrylic ? 'inset 0 0 0 1px ' + (wall.outline || 'rgba(21,21,21,.6)') : 'none';
      } else if (img) {
        // Frame as box-shadow, not outline: Safari leaves outline traces on the wall while the print resizes
        img.style.boxShadow = acrylic ? '0 0 0 1px rgba(21,21,21,.6)' : '0 0 0 6px #FFFFFF';
      }
      var st = print.querySelector('[data-psa-wall-size]');
      if (st) st.textContent = sizeLabel + ' cm' + (signed ? ' · ' + d.labels.signed : '') + (d.wallSuffix ? ' · ' + d.wallSuffix : '');
    }
    // Sticky bar ("Signed No. 7 / 25 · Fine-art print · 80 × 120 cm" on the signed-edition page: barPrefix)
    var bar = this.root.querySelector('[data-psa-atc-bar-meta]');
    if (bar) bar.textContent = (d.barPrefix ? d.barPrefix + ' · ' : signed ? d.labels.signed + ' · ' : '') + (finishLabel ? finishLabel + ' · ' : '') + sizeLabel + (dims && dims.w ? ' cm' : '');
    // Remember the variant in the address bar, like Shopify themes do
    if (fromUser && !d.quick && v && window.history && window.history.replaceState) {
      var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
    }
  };

  Product.prototype.setView = function (view) {
    this.state.view = view;
    var stage = this.root.querySelector('[data-psa-stage]');
    if (!stage) return;
    stage.setAttribute('data-m', view === 'photo' ? 'stage-photo' : 'stage-wall');
    stage.querySelectorAll('[data-psa-view]').forEach(function (el) { el.hidden = el.getAttribute('data-psa-view') !== view; });
    // With a room photo, the caption under the picture switches to the wall caption
    var cap = this.root.querySelector('[data-psa-stage-caption][data-wall]');
    if (cap) { var t = cap.getAttribute(view === 'wall' ? 'data-wall' : 'data-photo'); cap.textContent = t; cap.hidden = !t; }
    var tabs = this.root.querySelector('[data-psa-view-tabs]');
    if (tabs) tabs.querySelectorAll('[role="tab"]').forEach(function (t) {
      var on = t.getAttribute('data-value') === view;
      t.setAttribute('aria-selected', on ? 'true' : 'false'); t.setAttribute('tabindex', on ? '0' : '-1');
    });
  };

  Product.prototype.bind = function () {
    var self = this, root = this.root;
    root.addEventListener('click', function (e) {
      var opt = e.target.closest('.psa-vp__opt');
      if (opt && !opt.disabled && root.contains(opt)) {
        var name = opt.closest('[data-psa-picker]').getAttribute('data-psa-picker');
        var val = opt.getAttribute('data-value');
        if (name === 'edition') self.state.edition = val;
        else if (name === 'finish') self.state.finish = val;
        else if (name === 'size') self.state.size = val;
        self.render(true);
        return;
      }
      if (e.target.closest('[data-psa-show-wall]')) { self.setView('wall'); var st = root.querySelector('[data-psa-stage]'); if (st && st.getBoundingClientRect().top < 0) st.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); } // no smooth scroll under reduced motion (review 9 Oct 2026, finding 3)
      if (e.target.closest('[data-psa-bar-add]')) { var f = document.getElementById(root.getAttribute('data-form-id')); if (f) f.requestSubmit ? f.requestSubmit() : f.submit(); }
    });
    root.addEventListener('keydown', function (e) {
      var opt = e.target.closest && e.target.closest('.psa-vp__opt');
      if (!opt || ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].indexOf(e.key) < 0) return;
      e.preventDefault();
      var opts = Array.prototype.slice.call(opt.closest('.psa-vp__grid').querySelectorAll('.psa-vp__opt'));
      var i = opts.indexOf(opt), dir = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1;
      for (var k = 1; k <= opts.length; k++) { var j = (i + dir * k + opts.length) % opts.length; if (!opts[j].disabled) { opts[j].click(); opts[j].focus(); break; } }
    });
    root.addEventListener('psa:tab', function (e) { if (e.target.closest('[data-psa-view-tabs]')) self.setView(e.detail.value); });
    root.addEventListener('psa:qty', function (e) { var q = root.querySelector('[data-psa-qty-value]'); if (q) q.value = e.detail.value; });
  };

  Product.prototype.observeAtc = function () {
    var atc = this.root.querySelector('[data-psa-atc]'), bar = this.root.querySelector('[data-psa-atc-bar]');
    if (!atc || !bar || !('IntersectionObserver' in window)) return;
    var mq = window.matchMedia('(max-width: 959px)'), past = false;
    var update = function () { bar.hidden = !(mq.matches && past); };
    // The huge bottom margin counts "still below the screen" as visible, so a jump straight past the row (back button, story link) is caught too.
    new IntersectionObserver(function (entries) { var en = entries[0]; past = !en.isIntersecting && en.boundingClientRect.top < 0; update(); }, { rootMargin: '0px 0px 100000px 0px' }).observe(atc);
    if (mq.addEventListener) mq.addEventListener('change', update);
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-psa-product]').forEach(function (r) { if (!r._psa) { r._psa = new Product(r); } });
  }
  window.psaInitProducts = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
})();
